/**
 * Copyright (c) 2021 - 2022, Kodit Doo
 * Created by kodit-marko on 12/21/22
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { RacuniClient, TipRacuna } from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { RacunService } from '@kodit/core/services';
import { EotpremnicaFormService } from '../../../../../moduli/eotpremnica/src/lib/otpremnice/eotpremnica-form.service';

@Component({
  selector: 'kodit-pravilo-za-broj-racuna-dropdown',
  templateUrl: './pravilo-za-broj-racuna-dropdown.html',
  styleUrls: ['./pravilo-za-broj-racuna-dropdown.scss'],
})
export class PraviloZaBrojRacunaDropdownComponent implements OnInit, OnDestroy {
  /** Subs */
  private _pravilaSub: Subscription = new Subscription();

  /** Props */
  pravilaOptions: PraviloOption[] = [];

  /** I/O */
  @Input() formCtrl: FormControl | AbstractControl;
  @Input() formCtrlId: string = 'pravilo-za-broj';
  @Input() tipRacuna: TipRacuna = TipRacuna.EMPTY;
  @Input() racunNazivLabel: string = 'računa';

  constructor(
    private _racuniClient: RacuniClient,
    private _service: RacunService,
    private _fs: EotpremnicaFormService
  ) {}

  ngOnInit(): void {
    this._loadPravila();
  }

  get getTipDokumenta(): TipRacuna {
    if (this.tipRacuna === TipRacuna.EMPTY) {
      return this._service.getTipRacuna;
    }
    return this.tipRacuna;
  }

  private _loadPravila() {
    this._pravilaSub = this._racuniClient
      .getPravila(this.getTipDokumenta)
      .subscribe((result) => {
        this.pravilaOptions = []; // clear array
        result.data.pravilaDto.forEach((p) => {
          this.pravilaOptions.push({
            label: p.naziv,
            value: p.id,
            pravilo: '#DODAJ_PRAVILO',
          });
          const defaultValue = result.data.pravilaDto.find((x) => x.isDefault);
          if(!(this.tipRacuna === TipRacuna.EOTPREMNICA && this._fs.jeEdit)){
            this.formCtrl.patchValue(
              defaultValue?.id ?? this.pravilaOptions[0]?.value
            );
          }
        });
      });
  }

  ngOnDestroy() {
    this._pravilaSub.unsubscribe();
  }
}

export interface PraviloOption {
  label: string;
  value: number;
  pravilo: string;
}
